import {
  resolveCurrencyFromCoinPayType,
} from './paymentAssetConstants';

export const DEFAULT_MERCHANT_CHANNEL_FORM = {
  name: '',
  merchantIds: [],
  coinPayTypeId: '',
  type: '',
  sort: '0',
  currencyType: '',
  isRecharge: false,
  isWithdrawal: false,
  rechargeFee: '0',
  rechargeMin: '0',
  rechargeMax: '0',
  rechargeRebate: '0',
  withdrawalFee: '0',
  withdrawalMin: '0',
  withdrawalMax: '0',
  withdrawalRebate: '0',
};

export function rowToForm(row, defaultMerchantId, coinPayTypes) {
  if (!row) {
    const merchantIds = defaultMerchantId ? [String(defaultMerchantId)] : [];
    const firstCoinPayTypeId = coinPayTypes?.[0]?.id != null ? String(coinPayTypes[0].id) : '';
    const currencyType = resolveCurrencyFromCoinPayType(coinPayTypes, firstCoinPayTypeId);
    return {
      ...DEFAULT_MERCHANT_CHANNEL_FORM,
      merchantIds,
      coinPayTypeId: firstCoinPayTypeId,
      currencyType,
    };
  }
  return {
    name: row.name ?? '',
    merchantIds: (row.merchantIds || []).map(String),
    coinPayTypeId: row.coinPayTypeId != null ? String(row.coinPayTypeId) : '',
    type: row.type ?? '',
    sort: row.sort != null ? String(row.sort) : '0',
    currencyType: row.currencyType ?? resolveCurrencyFromCoinPayType(coinPayTypes, row.coinPayTypeId),
    isRecharge: Boolean(row.isRecharge),
    isWithdrawal: Boolean(row.isWithdrawal),
    rechargeFee: row.rechargeFee != null ? String(row.rechargeFee) : '0',
    rechargeMin: row.rechargeMin != null ? String(row.rechargeMin) : '0',
    rechargeMax: row.rechargeMax != null ? String(row.rechargeMax) : '0',
    rechargeRebate: row.rechargeRebate != null ? String(row.rechargeRebate) : '0',
    withdrawalFee: row.withdrawalFee != null ? String(row.withdrawalFee) : '0',
    withdrawalMin: row.withdrawalMin != null ? String(row.withdrawalMin) : '0',
    withdrawalMax: row.withdrawalMax != null ? String(row.withdrawalMax) : '0',
    withdrawalRebate: row.withdrawalRebate != null ? String(row.withdrawalRebate) : '0',
  };
}

function parseOptionalNumber(value, fallback = 0) {
  if (value === '' || value == null) {
    return fallback;
  }
  const num = Number(value);
  return Number.isNaN(num) ? fallback : num;
}

function trimOrNull(value) {
  const trimmed = value?.trim();
  return trimmed || null;
}

export function formToPayload(form, editingId, coinPayTypes) {
  const currencyType = resolveCurrencyFromCoinPayType(coinPayTypes, form.coinPayTypeId)
    || form.currencyType?.trim();
  const payload = {
    name: form.name?.trim(),
    merchantIds: (form.merchantIds || []).map((id) => Number(id)).filter((id) => !Number.isNaN(id)),
    coinPayTypeId: parseOptionalNumber(form.coinPayTypeId, null),
    type: trimOrNull(form.type),
    sort: parseOptionalNumber(form.sort, 0),
    currencyType,
    isRecharge: Boolean(form.isRecharge),
    isWithdrawal: Boolean(form.isWithdrawal),
    rechargeFee: parseOptionalNumber(form.rechargeFee, 0),
    rechargeMin: parseOptionalNumber(form.rechargeMin, 0),
    rechargeMax: parseOptionalNumber(form.rechargeMax, 0),
    rechargeRebate: parseOptionalNumber(form.rechargeRebate, 0),
    withdrawalFee: parseOptionalNumber(form.withdrawalFee, 0),
    withdrawalMin: parseOptionalNumber(form.withdrawalMin, 0),
    withdrawalMax: parseOptionalNumber(form.withdrawalMax, 0),
    withdrawalRebate: parseOptionalNumber(form.withdrawalRebate, 0),
  };
  if (editingId != null) {
    payload.id = editingId;
  }
  return payload;
}

export function formatSupportedMerchants(row) {
  const list = row?.supportedMerchants;
  if (!list?.length) {
    return '—';
  }
  return list.map((item) => item.name || item.merchantCode || item.id).join('、');
}

export function formatAmountRange(min, max) {
  const minText = min != null ? min : '0';
  const maxText = max != null ? max : '0';
  return `${minText} ~ ${maxText}`;
}
